import React, { useState } from 'react';
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  Text,
  ModalFooter,
  Flex,
  Spacer
} from '@chakra-ui/react';
import { useAuthContext } from '../../../../hooks/useAuthContext';
import { FileUploader } from "react-drag-drop-files";
import { useParams } from 'react-router-dom';

const PDFImportModal = ({ data, updateBotData, storedBot, setStoredBot, addDataSource, changeDatasourceStatus, isOpen, onClose }) => {
  const [inputValue, setInputValue] = useState('');
  const { user } = useAuthContext();
  const fileTypes = ["PDF"];

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const botData = data;

  const handleChange = (file) => {
    setFile(file);
  };

  const deleteFile = (index) => {
    setFile(null)
  };

  const handleButtonClick = () => {

    setLoading(true);

    if (!file) {
      alert('Please provide a file.');
      setLoading(false);
      return;
    }


    const doc = {
        name: file.name,
        type: 'File',
        status: 'Processing',
        charCount: 'Processing'
    }


    const formData = new FormData();
    formData.append("file", file);
  
    fetch(`${process.env.REACT_APP_API_URL}/create/upload/${id}/pdf`, {
        method: 'POST',
        headers: {'Authorization': `Bearer ${user.data.token}`},
        body: formData
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(errorData => {
          throw new Error(JSON.stringify(errorData));
        });
      }
      return response.json()
    }).then(data => {

        const storedDoc = {
            name: file.name,
            type: 'file',
            pdfUUid: data.pdfUuid,
            charCount: data.charCount,
            originalname: data.originalname,
        }

        const updatedBot = {...botData, files: [...botData.files, storedDoc]}

        updateBotData(updatedBot)
        onClose();
        setFile(null);
        setLoading(false);
        


        
    }).catch(error => {
      try {
        const errorObj = JSON.parse(error.message);

        if (errorObj.error === 'Character limit exceeded') {
          alert('This document exceeds your character limit. Please upgrade your plan to process larger documents.');
        } 
      } catch (e) {
        alert('Your file could not be processed. Common errors include: file too large (> 10 MB), file not a PDF, file name contains non ASCII Characters, or file corrupted.');
      }
      
      setLoading(false);
    })

    // Handle the button click action here
    console.log('Button clicked with input value:', inputValue);
  };

  return (
    <Modal size="lg" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Upload a PDF Document</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box>
            <FormControl>
            <Text mb = "5" p = "2" fontSize="sm">Add a file max 30MB</Text>

            <FileUploader handleChange={handleChange} name="file" types={fileTypes} />

            {file && <Flex mt = "3" alignItems = "center">
                <Text>{file.name}</Text>
                <Spacer />
                <Button colorScheme = "red" onClick={() => deleteFile()}>Delete</Button>
            </Flex>}

            <Text mb = "5" p = "2" fontSize="sm">Your Botsheets plan may have document character limits, so shorter docs are faster to process and more cost effective for you.</Text>
            </FormControl>
          </Box>
        </ModalBody>
        <ModalFooter>
            <Button isLoading = {loading} colorScheme='green' mr={3} onClick={handleButtonClick}>
              Upload PDF
            </Button>
          </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PDFImportModal;